module.exports = __webpack_public_path__ + "img/p2-76.1c5eaeaa.png";